
let vm: any = null;

export const setVm = (v: any) => {
    vm = v;
};

export const getVm = () => {
    return vm;
};
